import React, { useEffect, useContext} from 'react';
import { Box, TextField, Typography, Button, Stack, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AuthContext from '../../contexts/AuthContext';
import { setSnackDetails, setMetaData, setSweetAlert } from '../../service/actions/common';
import axios from 'axios';

import { useFormik } from 'formik';
import * as yup from 'yup';

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
// min 8 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.

const validationSchema = yup.object({
    full_name: yup
        .string('Enter Full Name')
        .trim()
        .required('Full Name is required'),
    password: yup
        .string('Enter a Password.')
        .trim()
        .matches(passwordRules, { message: "Please create a stronger password. min 8 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit." })
        .required('Password is required'),
    email: yup
        .string('Enter your email')
        .trim()
        .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Enter a valid email')
        .required('Email is required'),    
    });

const CreateAdminUsers = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token, user } = useContext(AuthContext);
    const catchError = async (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                navigate('/sign-in');
            } else if (error.response.status >= 500) {
                dispatch(setSweetAlert({ open: true, title: 'Server Error', text: '' }));
            } else if (error.response.status === 400) {
                dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
                return false;
            } else {
                dispatch(setSweetAlert({ open: true, title: 'Error', text: '' }));
            }
        } else if (error.request) {
            dispatch(setSweetAlert({ open: true, title: 'Connection Lost', text: '' }));
        } else {
            dispatch(setSweetAlert({ open: true, title: 'Error', text: 'An unknown error occurred.' }));
        }
    };
    useEffect(() => {
        dispatch(setMetaData(metaData));
        // eslint-disable-next-line
    }, []);

    const metaData  = {
        title: `Admin Users | Create`,
        description: `Admin Users | Create`
    };
    const formik = useFormik({
        initialValues: {
            full_name: '',
            email: '',
            password: '',
            status: 1
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                if (user && token ) {
                    const response = await axios.post('/user/create', values, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    if (response.status === 200) {
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'success'}));
                        navigate('/admin-users');
                    } else {
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'error'}));
                    }
                } else {
                    console.log('unauthorized');
                }
            } catch (error) {
                catchError(error);
            }
        },
    });

  return (
    <Box>
        <Stack direction="row" justifyContent="flex-start" sx={{ width: '100%' }}>
            <Button component={Link} to="/admin-users">
                <ArrowBackIcon />
            </Button>
            <Typography variant="h4">Admin User</Typography>            
            <Button color="primary" variant="contained" onClick={formik.handleSubmit} sx={{ borderRadius: 28, ml: "auto" }} >
                Save
            </Button>
        </Stack>
        <Box
            sx={{
                margin: 'auto',
                padding: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                border: '1px solid #ddd',
                borderRadius: 2,
                boxShadow: 1,
                mt:2,
                backgroundColor:'#FFF'
            }}
        >
        <Stack direction="column" spacing={2} sx={{ width: '40%', height: '70vh' }}>
            <TextField
                label="Full Name"
                name="full_name"
                id="full_name"
                type="text"
                required
                autoFocus
                value={formik.values.full_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.full_name && Boolean(formik.errors.full_name)}
                helperText={formik.touched.full_name && formik.errors.full_name}
            />
            <TextField
                label="Email"
                name="email"
                id="email"
                type="text"
                required
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />
            <TextField
                label="Password"
                name="password"
                id="password"
                type="password"
                required
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
            />

            <FormControl fullWidth variant="outlined" error={formik.touched.status && Boolean(formik.errors.status)}>
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                    id="status"
                    name="status"
                    label="Status"
                    labelId="status-label" 
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.status || 0}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                </Select>
            </FormControl>  
        </Stack>       
    </Box>
    </Box>
  );
};

export default CreateAdminUsers;